import { render, staticRenderFns } from "./Recupero.vue?vue&type=template&id=a7122494"
import script from "./Recupero.vue?vue&type=script&lang=js"
export * from "./Recupero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports